import {
  GET_DAILY_RATES_REQUEST,
  GET_DAILY_RATES_SUCCESS,
  GET_DAILY_RATES_FAILURE,
  CREATE_DAILY_RATE_REQUEST,
  CREATE_DAILY_RATE_SUCCESS,
  CREATE_DAILY_RATE_FAILURE,
  UPDATE_DAILY_RATE_REQUEST,
  UPDATE_DAILY_RATE_SUCCESS,
  UPDATE_DAILY_RATE_FAILURE,
  DELETE_DAILY_RATE_REQUEST,
  DELETE_DAILY_RATE_SUCCESS,
  DELETE_DAILY_RATE_FAILURE,
} from '../types';

const initialState = {
  dailyRates: [],
  pagination: {
    total: 0,
    page: 1,
    limit: 10,
    pages: 0
  },
  loading: false,
  error: null,
};

const dailyRateReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DAILY_RATES_REQUEST:
    case CREATE_DAILY_RATE_REQUEST:
    case UPDATE_DAILY_RATE_REQUEST:
    case DELETE_DAILY_RATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_DAILY_RATES_SUCCESS:
      return {
        ...state,
        loading: false,
        dailyRates: action.payload.data,
        pagination: action.payload.pagination,
        error: null,
      };

    case CREATE_DAILY_RATE_SUCCESS:
      return {
        ...state,
        loading: false,
        dailyRates: [action.payload, ...state.dailyRates],
        error: null,
      };

    case UPDATE_DAILY_RATE_SUCCESS:
      return {
        ...state,
        loading: false,
        dailyRates: state.dailyRates.map(rate =>
          rate.id === action.payload.id ? action.payload : rate
        ),
        error: null,
      };

    case DELETE_DAILY_RATE_SUCCESS:
      return {
        ...state,
        loading: false,
        dailyRates: state.dailyRates.filter(rate => rate.id !== action.payload),
        error: null,
      };

    case GET_DAILY_RATES_FAILURE:
    case CREATE_DAILY_RATE_FAILURE:
    case UPDATE_DAILY_RATE_FAILURE:
    case DELETE_DAILY_RATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default dailyRateReducer;

